module.exports = __webpack_public_path__ + "img/59_6.aa37cd9e.png";